import React from "react";
import { Container, Row } from "reactstrap";
import { Loader as LMLoader } from "@launchmetrics/lm-ui";

const Loader = ({size = 40}) => (
  <Container fluid >
    <Row className="d-flex justify-content-center align-items-center m-5">
      <LMLoader size={size} />
    </Row>
  </Container>
);

export default Loader;
